import React, {useState, useEffect, useContext} from 'react';
import {Calendar, momentLocalizer, NavigateAction, View} from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import {DataContext} from "../../contexts/dataContext";
import Translate from "react-translate-component";
import {translateService} from "../../services/TranslateService";
import { CircularProgress } from '@mui/material';

// Here is the link to the documentation for the calendar component
// https://jquense.github.io/react-big-calendar/examples/?path=/story/about-big-calendar--page

const localizer = momentLocalizer(moment);

interface FreeSlot {
    from: string;
    to: string | null;
}

interface FreeSlotIntervals {
    freeIntervals: FreeSlot[];
    nextFreeInterval: {
        from: string;
        to: string;
    };
}

interface FreeSlotsObject {
    freeSlots: FreeSlotIntervals;
}

const CalendarComponent = (freeSlots: FreeSlotsObject) => {
    const [events, setEvents] = useState([]);
    const dataContext = useContext(DataContext);
    const currentDate = moment(dataContext.searchParameters?.endDate).toDate();
    const maxDate = moment(currentDate).add(8, 'weeks').toDate();
    const [isLoaded, setIsLoaded] = useState(true);
    const [currentlyPreBooked, setCurrentlyPreBooked] = useState('');

    useEffect(() => {
        if (!isLoaded) return;
        setIsLoaded(true);
        if(freeSlots.freeSlots){
            let formattedEvents: any[] = [];

            if (freeSlots.freeSlots.nextFreeInterval === null) {
                if (freeSlots.freeSlots.freeIntervals.length === 0) {
                    setCurrentlyPreBooked(translateService.translate('vehicleSearch1.vehicleCalendarDataErr'));
                    return;
                }
                setCurrentlyPreBooked(translateService.translate('vehicleSearch1.vehiclePreReserved'));
                return;
            }

            freeSlots.freeSlots.freeIntervals.forEach((freeInterval: FreeSlot, i: number) => {
               if (i === 0) {
                   if(dataContext.searchParameters?.startDate){
                       formattedEvents.push({
                           title: <Translate content={'vehicleSearch1.Reserved'} />,
                           start: moment(dataContext.searchParameters?.startDate).toDate(),
                           end: moment(freeInterval.from).toDate(),
                           free: true
                       });
                       formattedEvents.push({
                           title: <Translate content={'vehicleSearch1.Reserved'} />,
                           start: moment(freeInterval.from).toDate(),
                           end: freeInterval.to ? moment(freeInterval.to).toDate() : moment(dataContext.searchParameters?.endDate).toDate(),
                           free: true
                       });
                   }
               }
            });

            if (events !== formattedEvents) {
                // @ts-ignore
                setEvents(formattedEvents);
            }
        }
    }, [dataContext.searchParameters?.startDate, dataContext.searchParameters?.endDate, freeSlots, isLoaded]);

    useEffect(() => {
        if(events.length !== 0){
            setIsLoaded(false);
            setCurrentlyPreBooked('');
        }
    }, [events]);

    const handleNavigate = (newDate: Date, view: View, action: NavigateAction) => {
        const prevButton = document.querySelector('.rbc-btn-group > button:nth-child(2)');
        const nextButton = document.querySelector('.rbc-btn-group > button:nth-child(3)');
        if (action === 'NEXT' && moment(newDate).isAfter(maxDate) && nextButton) {
            nextButton.setAttribute('disabled', 'true');
        } else if (action === 'PREV' && moment(newDate).isBefore(dataContext.searchParameters?.startDate) && prevButton) {
            prevButton.setAttribute('disabled', 'true');
        } else {
            if (nextButton) {
                nextButton.removeAttribute('disabled');
            }
            if (prevButton) {
                prevButton.removeAttribute('disabled');
            }
        }
    }

    // @ts-ignore
    return (
        <div>
            {isLoaded ?
                currentlyPreBooked === '' ?
                    <div className="d-flex justify-content-center my-2 pb-3">
                        <CircularProgress color={"warning"}/>
                    </div>
                    :
                    <div className="text-center p-2">
                        <p >{currentlyPreBooked}</p>
                    </div>
                : <Calendar
                    allDayAccessor=""
                    localizer={localizer}
                    events={events} // events is an array of objects
                    startAccessor="start"
                    endAccessor="end"
                    views={['week']}
                    messages={{
                        next: '>',
                        previous: '<',
                        allDay: '',
                        today: `${translateService.translate('vehicleSearch1.today')}`
                    }}
                    showMultiDayTimes={true}
                    defaultView="week"
                    selectable={true}
                    style={{ height: 500 }}
                    onNavigate={handleNavigate}
                />}
        </div>
    );
};

export default CalendarComponent;